module.exports = __tmimport("~endpoint:{controller: \'customized/api\', action: \'cart_when\'}");